import {
  Feed as FeedComponent,
  FeedProps,
} from '@tribeplatform/react-components/Feed'

import { BC } from '../../types/index.js'

export const FeedBlock: BC<FeedProps> = FeedComponent
